export const DEFAULT_ADMIN_SEARCH_DEBOUNCE_MS = 180
export const DEFAULT_ADMIN_PAGE_SIZE = 25

export const toPositiveInt = (value, fallback) => {
  const parsed = Number(value)
  return Number.isInteger(parsed) && parsed > 0 ? parsed : fallback
}

export const paginateRows = (rows, page = 1, pageSize = DEFAULT_ADMIN_PAGE_SIZE) => {
  const list = Array.isArray(rows) ? rows : []
  const normalizedPage = toPositiveInt(page, 1)
  const normalizedPageSize = toPositiveInt(pageSize, DEFAULT_ADMIN_PAGE_SIZE)
  const start = (normalizedPage - 1) * normalizedPageSize
  const end = start + normalizedPageSize
  return {
    items: list.slice(start, end),
    total: list.length,
    page: normalizedPage,
    pageSize: normalizedPageSize,
    totalPages: Math.max(1, Math.ceil(list.length / normalizedPageSize)),
  }
}

export const isDataStale = (timestampIso, thresholdMs = 120000) => {
  if (!timestampIso) return true
  const ts = Date.parse(timestampIso)
  if (!Number.isFinite(ts)) return true
  return Date.now() - ts > Number(thresholdMs || 0)
}

export const toQueryStringValue = (value, fallback = '') => {
  const normalized = String(value ?? '').trim()
  return normalized || fallback
}

